import { useState, useEffect } from 'react'

import { Offer } from 'types/offer'

import { useStateManager } from 'components/context/StateManager'
import { getChancePrice, getStandardPrice } from 'utils/offerHelper'
import { checkoutOrder } from 'services/api'

function useCheckout(): { isLoading: boolean; offer: Offer } {
  const [state, setState] = useStateManager()
  const [isLoading, setIsLoading] = useState(true)
  const { offer } = state

  useEffect(() => {
    if (state.user && state.offer && state.offer?.currency) {
      setIsLoading(false)

      return
    }

    const loadCheckoutData = async () => {
      const { offer, user } = await checkoutOrder()

      const {
        offer_prices,
        currency: { symbol, name },
        paymodes,
        id,
        inline_checkout,
      } = offer
      const standardPrice = getStandardPrice(offer_prices)
      const chancePrice = getChancePrice(offer_prices)

      const offerData: Offer = {
        price: standardPrice.amount,
        price_lastchance: chancePrice.amount,
        old_price: standardPrice.amount,
        new_price: chancePrice.amount,
        currency: symbol,
        currency_name: name,
        payment_methods: paymodes,
        id: id,
        inline_checkout: inline_checkout,
      }

      setState({ ...state, user: user, offer: offerData })
      setIsLoading(false)
    }

    loadCheckoutData()
  }, [state, setState])

  return { isLoading, offer }
}

export default useCheckout
